var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Navbar'),_c('div',{staticClass:"pa-lg-12 pa-2"},[_c('div',{attrs:{"id":"stats"}},[_c('v-container',[_c('v-row',[_c('v-col',[(_vm.rows.length > 0)?_c('DataTable',{attrs:{"columns":_vm.headers,"rows":_vm.rows}}):_vm._e(),(_vm.rows.length === 0)?_c('cant-order',{attrs:{"case":"stats"}}):_vm._e()],1)],1)],1)],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }